import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import {useSelector} from "react-redux";
import ImageWithFallback from "components/ImageWithFallback";
import Rating from "components/Rating";
import {useCallback, useEffect, useState} from "react";
import calcOpenNow from "lib/utils/calcOpenNow";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {Button} from "@mui/material";
import {useTranslation} from "next-i18next";
import {checkMobile, locate} from "../../utils/helper";

export default function LocationHeader() {
  const location = useSelector(state => state.location.location)
  const [openNow, setOpenNow] = useState(false)
  const [closeTime, setCloseTime] = useState('')
  const [geo, setGeo] = useState({
    located: false,
    latitude: 0,
    longitude: 0,
  })
  const { t } = useTranslation()

  useEffect(() => {
    console.log('location: ', location)
    const {isOpen, closeTime} = calcOpenNow(location.business_hours, location.timezone)
    setOpenNow(isOpen)
    setCloseTime(closeTime)
    locate(setGeo)
    setLoaded(true)
  }, [])

  const [isMobile, setIsMobile] = useState(false)
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    if (loaded) {
      setIsMobile(checkMobile())
    }
  }, [loaded])

  useEffect(() => {
    console.log('here: ', checkMobile(), isMobile)
  }, [isMobile])

  return (
    <Wrapper>
      <Container className={isMobile ? "flex flex-col" : "flex"}>
        {
          loaded ?
              <>
                {
                  isMobile ?
                      <div className={"items-center self-center relative w-32 mr-8 after:block after:content-[''] after:pb-[100%] after:w-full"}>
                        <ImageWithFallback
                            src={location.avatar_url}
                            alt={location.name}
                            className={'object-contain'}
                            fallback={{size: '640x1:1'}}
                        />
                      </div> :
                      <div className={"relative w-48 mr-8 after:block after:content-[''] after:pb-[100%] after:w-full"}>
                        <ImageWithFallback
                            src={location.avatar_url}
                            alt={location.name}
                            className={'object-contain'}
                            fallback={{size: '640x1:1'}}
                        />
                      </div>
                }
                <div className={isMobile ? "w-fit" :"grow shrink"}>
                  <h1 className={"text-2xl font-bold mb-2"}>
                    {location.name}
                  </h1>
                  <div className="flex flex-nowrap items-center mb-4">
                    <div className="text-xs mr-2">
                      {location.rating.toFixed(1)}
                    </div>
                    <Rating
                        value={location.rating || 5}
                        precision={0.5}
                        readOnly
                        className={'mr-2'}
                    />
                    <div className="text-xs">
                      ({location.reviews_count})
                    </div>
                  </div>
                  <div className={isMobile ? "w-fit grid gap-2 grid-cols-2 text-sm mb-4" : "w-[400px] grid gap-2 grid-cols-2 text-sm mb-4"}>
                    <div className="flex items-center">
                      <div className="w-6 mr-1 text-center text-gray-500">
                        <FontAwesomeIcon icon={solid('id-card')}/>
                      </div>
                      {location.license_type === 'Medical' ? t('home:license_medical') : location.license_type}
                    </div>
                    <div className="flex items-center">
                      <div className="w-6 mr-1 text-center text-gray-500">
                        <FontAwesomeIcon icon={solid('clock')}/>
                      </div>
                      {
                        openNow
                            ? <>
                              <span className={'text-primary'}>{`${t('home:store_opentime')} ${closeTime}`};</span>
                            </>
                            : t('home:closed')
                      }
                    </div>
                    <div className="flex items-center">
                      <div className="w-6 mr-1 text-center text-gray-500">
                        <FontAwesomeIcon icon={solid('grid-2')}/>
                      </div>
                      {t(`home:${location.location_type}`)}
                    </div>
                    <div className="flex items-center">
                      <div className="w-6 mr-1 text-center text-gray-500">
                        <FontAwesomeIcon icon={solid('check-circle')}/>
                      </div>
                      {t('home:store_license')}
                    </div>
                  </div>
                  <a href={`tel:${location.phone_number}`}>
                    <Button
                        variant={'outlined'} className={'mr-4'}
                        startIcon={<FontAwesomeIcon icon={solid('phone-volume')}/>}
                    >
                      {location.phone_number}
                    </Button>
                  </a>
                  <a href={geo.located ? `https://maps.google.com/maps/dir/${geo.latitude},${geo.longitude}/${location.latitude},${location.longitude}` : `https://www.google.com/maps/place/${location.latitude},${location.longitude}`}
                     target={'_blank'} rel={'noreferrer'}
                     className={'font-bold text-primary-dark'}
                  >
                    <Button
                        variant={'outlined'}
                        startIcon={<FontAwesomeIcon icon={solid('map-location-dot')}/>}
                    >
                      {t('home:store_direction')}
                    </Button>
                  </a>
                </div> </> : <span>{t('home:loading')}</span>

        }
      </Container>
    </Wrapper>
  )
}
